module.exports = __webpack_public_path__ + "img/frame (223).276ea800.jpg";